const PATH = "/api/v1/authorization";

const ENDPOINTS = {
  AUTHORIZATION_MY_ACCESS: "/my/access/",
  AUTHORIZATION_MY_ASSOCIATION: "/my/association/",
};

export type AuthorizationEndpoints = keyof typeof ENDPOINTS;
export const AuthorizationCollection = { PATH, ENDPOINTS };
